module.exports = __webpack_public_path__ + "img/project6_6.png.0e5f9b06.webp";